import { render, staticRenderFns } from "./SosEditShiftCard.vue?vue&type=template&id=572325ee&scoped=true&lang=pug"
import script from "./SosEditShiftCard.vue?vue&type=script&lang=js"
export * from "./SosEditShiftCard.vue?vue&type=script&lang=js"
import style0 from "./SosEditShiftCard.vue?vue&type=style&index=0&id=572325ee&prod&lang=scss"
import style1 from "./SosEditShiftCard.vue?vue&type=style&index=1&id=572325ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572325ee",
  null
  
)

export default component.exports